module.exports = __webpack_public_path__ + "static/screenshot1-2a1a30e64aeb6e6d9fc46ad5945d18cf.png";